import React, { useState } from "react";
import PropTypes from "prop-types";

import { Select, message, Modal } from "antd";
import { useOperators } from "../../use-operators";
import api from "../../../../../services/api";
import { isSuperUser } from "../../../../../utils/is-superuser";

export const SelectOperador = ({ idParcela, currentOperatorId }) => {
  const { operadores, isLoading } = useOperators();
  const [selectedOperator, setSelectedOperator] = useState(currentOperatorId);

  const askSave = value => {
    if (value === null) {
      Modal.confirm({
        title: "Remover operador",
        content: `Deseja remover o operador dessa parcela?`,
        onCancel: () => null,
        onOk() {
          return api
            .post(`/contratos/parcela/${idParcela}/operador/`, {
              operador_id: value
            })
            .then(() => {
              message.success("Operador alterado com sucesso.");
              setSelectedOperator(value);
            })
            .catch(err => {
              console.error(err);
              message.error("Falha ao alterar operador.");
            });
        }
      });
      return;
    }

    const operatorName = operadores.find(o => o.id === value).name;

    Modal.confirm({
      title: "Alterar operador",
      content: `Deseja alterar o operador da parcela para \"${operatorName}\"?`,
      onCancel: () => null,
      onOk() {
        return api
          .post(`/contratos/parcela/${idParcela}/operador/`, {
            operador_id: value
          })
          .then(() => {
            message.success("Operador alterado com sucesso.");
            setSelectedOperator(value);
          })
          .catch(err => {
            console.error(err);
            message.error("Falha ao alterar operador.");
          });
      }
    });
  };

  return (
    <Select
      showSearch
      style={{ width: "100%", minWidth: "150px" }}
      value={selectedOperator ? selectedOperator : undefined}
      placeholder="Selecione"
      onChange={askSave}
      disabled={!isSuperUser()}
      loading={isLoading}
      filterOption={(input, option) =>
        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      <Select.Option value={null}>Selecione</Select.Option>
      {operadores.map(operador => (
        <Select.Option key={operador.id} value={operador.id}>
          {operador.name}
        </Select.Option>
      ))}
    </Select>
  );
};

SelectOperador.propTypes = {
  idParcela: PropTypes.number,
  currentOperatorId: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/pages/Pasta/Contratos/Contrato/SelectOperador/index.jsx